import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Starts every newly opened page at the top. Back/forward (POP) keeps the browser's
 * own position, and hash links (#section) are left to scroll to their target.
 */
export const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (navigationType === 'POP' || hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    // Pages with their own scrolling area (e.g. full-height workspaces) reset too
    document.querySelectorAll<HTMLElement>('[data-scroll-reset]').forEach((el) => {
      el.scrollTop = 0;
    });
  }, [pathname, hash, navigationType]);

  return null;
};
